import { API_URLS } from './config';

// 登录 API
export const loginApi = {
  // 登录
  login: async (user_name, pass) => {
    try {
      const response = await fetch(API_URLS.LOGIN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_name,
          pass
        }),
        timeout: 300000 // 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('登录失败:', error);
      throw error;
    }
  },
  
  // 退出登录
  logout: async (token) => {
    try {
      const response = await fetch(API_URLS.LOGOUT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        timeout: 300000 // 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('退出登录失败:', error);
      throw error;
    }
  },
  
  // 获取APK版本列表
  getApkList: async (token, lan, page, limit, apkType) => {
    try {
      const response = await fetch(API_URLS.APK_LIST, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          lan,
          page,
          limit,
          apkType
        }),
        timeout: 300000 // 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('获取APK版本列表失败:', error);
      throw error;
    }
  },
  
  // 获取APK版本号列表（下拉列表）
  getApkVersionList: async (token, lan, cur, apkType) => {
    try {
      const response = await fetch(API_URLS.APK_VERSION_LIST, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          lan,
          cur,
          apkType
        }),
        timeout: 300000 // 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('获取APK版本号列表失败:', error);
      throw error;
    }
  },
  
  // 更新备注
  editRemark: async (token, id, remark) => {
    try {
      const response = await fetch(API_URLS.EDIT_REMARK, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          id,
          remark
        }),
        timeout: 300000 // 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('更新备注失败:', error);
      throw error;
    }
  },
  
  // 上传APK
  uploadApk: async (token, version, min_version, lan, remark, file, apkType) => {
    try {
      // 构建URL，包含查询参数
      const url = `${API_URLS.UPLOAD_APK}?version=${encodeURIComponent(version)}&min_version=${encodeURIComponent(min_version)}&lan=${encodeURIComponent(lan)}&remark=${encodeURIComponent(remark)}&apkType=${encodeURIComponent(apkType)}`;
      
      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
          // 注意：Content-Type会自动设置为multipart/form-data
        },
        body: formData,
        timeout: 300000 // 上传文件超时时间设置为30秒
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('上传APK失败:', error);
      throw error;
    }
  },
  
  // 替换APK
  replaceApk: async (token, id, remark, file) => {
    try {
      // 构建URL，包含查询参数
      const url = `${API_URLS.REPLACE_APK}?id=${encodeURIComponent(id)}&remark=${encodeURIComponent(remark)}`;
      
      // 创建FormData对象
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
          // 注意：Content-Type会自动设置为multipart/form-data
        },
        body: formData,
        timeout: 300000 // 上传文件超时时间设置为30秒
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('替换APK失败:', error);
      throw error;
    }
  },
  
  // 获取下一个版本号
  getNewApkVerNo: async (token, lan, apkType) => {
    try {
      const response = await fetch(API_URLS.GET_NEW_VERSION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ lan, apkType }),
        timeout: 300000 // 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('获取下一个版本号失败:', error);
      throw error;
    }
  },

  // 获取当前节点
  getCurrentDomain: async () => {
    try {
      const response = await fetch(API_URLS.GET_CURRENT_DOMAIN, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 3000// 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('获取当前节点失败:', error);
      throw error;
    }
  },

  // 获取节点列表
  getDomainList: async (token) => {
    try {
      const response = await fetch(API_URLS.GET_DOMAIN_LIST, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        timeout: 3000// 请求超时时间
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('获取节点列表失败:', error);
      throw error;
    }
  }
};

export default loginApi;